export const mpsRouteNames = {
  root: '/',
  auth: 'auth',
  login: 'login',
  logout: 'logout',
};
